import { render } from "./CurrencyCreateComponent.vue?vue&type=template&id=5741aa43"
import script from "./CurrencyCreateComponent.vue?vue&type=script&lang=js"
export * from "./CurrencyCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Currency/CurrencyCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5741aa43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5741aa43', __exports__)) {
    api.reload('5741aa43', __exports__)
  }
  
  module.hot.accept("./CurrencyCreateComponent.vue?vue&type=template&id=5741aa43", () => {
    api.rerender('5741aa43', render)
  })

}


export default __exports__